const NEW_PIN_REGEX = /^\d{4}$/;

function validateNewPin(value) {
  if (NEW_PIN_REGEX.test(value) === false) {
    return "Must contain 4 digits";
  }

  const d = value.split("").map((digitStr) => Number(digitStr));

  if (d[0] === d[1] && d[1] === d[2] && d[2] === d[3]) {
    return "Must not be a single repeating digit";
  }

  if (
    (d[0] + 1 === d[1] && d[1] + 1 === d[2] && d[2] + 1 === d[3]) ||
    (d[0] === d[1] + 1 && d[1] === d[2] + 1 && d[2] === d[3] + 1)
  ) {
    return "Must not be 4 consecutive digits";
  }

  return null;
}

function validateConfirmPin(value, { data }) {
  if (data.newPin === "") {
    return null;
  }

  if (data.newPin !== value) {
    return "Must match the New PIN";
  }

  return null;
}

function parseSendOtpResponse(data) {
  const accountToken = data?.account_token;

  if (accountToken?.length !== 12) {
    return null;
  }

  const maskedMobileNumber = data?.masked_mobile;

  if (!maskedMobileNumber) {
    return null;
  }

  const publicKey = data?.public_key;

  if (!publicKey) {
    return null;
  }

  const rsaId = data?.rsa_id;

  if (!rsaId) {
    return null;
  }

  const finalisePinChangeAction = data?.links?.find(
    ({ rel }) => rel === "finalise-pin-change",
  );

  if (!finalisePinChangeAction) {
    return null;
  }

  const resendOtpAction = data?.links?.find(({ rel }) => rel === "resend-otp");

  if (!resendOtpAction) {
    return null;
  }

  return {
    accountToken,
    maskedMobileNumber,
    publicKey,
    rsaId,
    finalisePinChangeAction,
    resendOtpAction,
  };
}

export { validateNewPin, validateConfirmPin, parseSendOtpResponse };
